import { observable } from 'mobx';
import { useEffect } from 'react';
import BaseStore from '@src/utils/store/base-store';
import useMount from '@src/utils/hooks/use-mount';
import useFunLinkPageData from '@src/utils/use-fun-link-page-data.js';

class DownloadStore extends BaseStore {
  @observable isActive = false;

  @observable
  layerData = {
    download: {
      launcher_download_link: '',
      steam_download_link: '',
      xbox_download_link: ''
    }
  };

  back = () => {
    this.$history.goBack();
  };

  use() {
    super.use();
    const funlinkData = useFunLinkPageData();

    useEffect(
      () => {
        if (funlinkData) {
          this.layerData = funlinkData;
        }
      },
      [funlinkData]
    );
    useMount(() => {
      this.isActive = true;
    });
  }
}

export default DownloadStore;
